export enum ActionType {
  Create = "create",
  Update = "update",
  Delete = "delete",
}
export enum Target {
  Agents = "agents", //AccountCircle
  BlockedEmails = "blockedEmails", //AlertSpam
  CannedResponses = "cannedResponses", //CannedResponse
  ContactForms = "contactForms", //EmailLetter
  CustomFields = "customFields", //Adjust
  Domains = "domains", //World
  Integrations = "integrations", //Apps
  Licenses = "licenses", //Settings
  Macros = "macros", //Automation
  ForwardingAddresses = "forwardingAddresses", //EmailLetter
  ReplyAddresses = "replyAddresses", //Reply
  ReportGenerator = "reportGenerator", //Report
  Workflows = "workflows", //Automation
  Screencasts = "screencasts", //PlayerRecord
  Tags = "tags", //Tag
  Teams = "teams", //Group
  EmailTemplates = "emailTemplates", //EmailAt
  CustomViews = "customViews", //Filter
  Webhooks = "webhooks", //Webhook
  TrustedEmails = "trustedEmails", //AlertSpam
}
